const c = ["#0A8BFE", "#4F9C20", "#EC5962", "#fc8f3c"];

let colors = [...c];
new Array(100).fill("").forEach((item) => {
  colors = [...colors, ...c];
});

export default colors;
